import { createBrowserRouter } from 'react-router-dom';
import App from '../app';
import ProtectedRoute from '../components/ProtectedRoute/ProtectedRoute';
import Dashboard from '../pages/Dashboard';
import Drivers from '../pages/Drivers';
import DriversForm from '../pages/Drivers/DriversForm';
import LoginAws from '../pages/LoginAws';
import NotFound from '../pages/NotFound';
import Orders from '../pages/Orders';
import Vehicles from '../pages/UserVehicles';
import UserVehicleDetails from '../pages/UserVehicles/UserVehicleDetails';
import VehicleForm from '../pages/UserVehicles/VehicleForm';
import DebtsListing from '../pages/Debts';
import VehicleDetails from '../pages/UserVehicles/UserVehicleDetails/VehicleDetails';
import CreditBatchPayment from '../pages/CreditBatchPayment';
import PixBatchPayment from '../pages/PixBatchPayment';
import Proof from '../pages/Proof';
import Users from '../pages/Users';
import UsersForm from '../pages/Users/UsersForm';
import PaymentInBatches from '../pages/PaymentInBatches';
import ExportsListing from '../pages/Exports';
import CreditPayment from '../pages/CreditPayment';
import PixPayment from '../pages/PixPayment';

const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginAws />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <App />
      </ProtectedRoute>
    ),
    errorElement: <NotFound />,
    children: [
      {
        path: '/',
        element: <Vehicles />,
      },
      {
        path: '/dashboard',
        element: <Dashboard />,
      },
      {
        path: '/vehicles',
        element: <Vehicles />,
      },
      {
        path: '/vehicles/details',
        element: <UserVehicleDetails />,
      },
      {
        path: '/vehicles/details/payments',
        element: <VehicleDetails />,
      },
      {
        path: '/drivers',
        element: <Drivers />,
      },
      {
        path: '/drivers/create',
        element: <DriversForm />,
      },
      {
        path: '/drivers/edit/:id',
        element: <DriversForm />,
      },
      {
        path: '/users',
        element: <Users />,
      },
      {
        path: '/users/create',
        element: <UsersForm />,
      },
      {
        path: '/users/edit/:id',
        element: <UsersForm />,
      },
      {
        path: '/orders',
        element: <Orders />,
      },
      {
        path: '/users',
        element: <Users />,
      },
      {
        path: '/users/create',
        element: <UsersForm />,
      },
      {
        path: '/users/edit/:id',
        element: <UsersForm />,
      },
      {
        path: '/vehicles/register',
        element: <VehicleForm />,
      },
      {
        path: '/debts',
        element: <DebtsListing />,
      },
      {
        path: '/debts/batch-payment',
        element: <PaymentInBatches />,
      },
      {    
        path: '/exports',
        element: <ExportsListing />,
      },
      {
        path: '/debts/batch-payment/credit-card',
        element: <CreditBatchPayment />,
      },
      {
        path: '/debts/batch-payment/pix',
        element: <PixBatchPayment />,
      },
      {
        path: '/debts/credit-card',
        element: <CreditPayment />,
      },
      {
        path: '/debts/pix',
        element: <PixPayment />,
      },
      {
        path: '/proof',
        element: <Proof />,
      },
    ],
  },
]);

export default router;
